export const EnevelopIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			strokeWidth="1.9"
			stroke="currentColor"
			className="absolute top-2"
			width="20"
			height="15"
			viewBox="0 0 20 21"
			fill="none"
			style={{ left: "10px", top: "14px", color: "#757575" }}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
			/>
		</svg>
	);
};

export const PasswordLockIcon = () => {
	return (
		<svg
			className="absolute left-3 top-3"
			width="20"
			height="21"
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.33325 18.8332V7.29159H6.04159V5.29159C6.04159 4.19645 6.42774 3.26294 7.20004 2.49107C7.97235 1.71919 8.90638 1.33325 10.0021 1.33325C11.0979 1.33325 12.0312 1.71919 12.802 2.49107C13.5728 3.26294 13.9583 4.19645 13.9583 5.29159V7.29159H16.6666V18.8332H3.33325ZM4.58325 17.5832H15.4166V8.54159H4.58325V17.5832ZM10.0034 14.6665C10.4455 14.6665 10.8228 14.5136 11.1353 14.2076C11.4478 13.9016 11.6041 13.5337 11.6041 13.104C11.6041 12.6874 11.4467 12.3089 11.1318 11.9686C10.817 11.6284 10.4385 11.4582 9.99642 11.4582C9.55431 11.4582 9.177 11.6284 8.8645 11.9686C8.552 12.3089 8.39575 12.6909 8.39575 13.1145C8.39575 13.5381 8.55317 13.9027 8.868 14.2082C9.18284 14.5138 9.56131 14.6665 10.0034 14.6665ZM7.29159 7.29159H12.7083V5.29159C12.7083 4.53927 12.4452 3.8998 11.919 3.37319C11.3929 2.84657 10.754 2.58325 10.0024 2.58325C9.25074 2.58325 8.61103 2.84657 8.08325 3.37319C7.55547 3.8998 7.29159 4.53927 7.29159 5.29159V7.29159Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const HomeIcon = ({ color = '#15295F' }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4 19V10C4 9.68333 4.07083 9.38333 4.2125 9.1C4.35417 8.81667 4.55 8.58333 4.8 8.4L10.8 3.9C11.15 3.63333 11.55 3.5 12 3.5C12.45 3.5 12.85 3.63333 13.2 3.9L19.2 8.4C19.45 8.58333 19.6458 8.81667 19.7875 9.1C19.9292 9.38333 20 9.68333 20 10V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H15C14.7167 21 14.4792 20.9042 14.2875 20.7125C14.0958 20.5208 14 20.2833 14 20V15C14 14.7167 13.9042 14.4792 13.7125 14.2875C13.5208 14.0958 13.2833 14 13 14H11C10.7167 14 10.4792 14.0958 10.2875 14.2875C10.0958 14.4792 10 14.7167 10 15V20C10 20.2833 9.90417 20.5208 9.7125 20.7125C9.52083 20.9042 9.28333 21 9 21H6C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19Z"
				fill={color} />
		</svg>

	)
}

export const TodayDispenseIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.5 18C13.8 18 13.2083 17.7583 12.725 17.275C12.2417 16.7917 12 16.2 12 15.5C12 14.8 12.2417 14.2083 12.725 13.725C13.2083 13.2417 13.8 13 14.5 13C15.2 13 15.7917 13.2417 16.275 13.725C16.7583 14.2083 17 14.8 17 15.5C17 16.2 16.7583 16.7917 16.275 17.275C15.7917 17.7583 15.2 18 14.5 18ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V3C6 2.71667 6.09583 2.47917 6.2875 2.2875C6.47917 2.09583 6.71667 2 7 2C7.28333 2 7.52083 2.09583 7.7125 2.2875C7.90417 2.47917 8 2.71667 8 3V4H16V3C16 2.71667 16.0958 2.47917 16.2875 2.2875C16.4792 2.09583 16.7167 2 17 2C17.2833 2 17.5208 2.09583 17.7125 2.2875C17.9042 2.47917 18 2.71667 18 3V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20Z"
				fill="white" />
		</svg>

	)
}

export const X_MarkIcon = () => {
	return (
		<>
			<svg style={{ color: 'white' }} width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
				<path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" fill="white" />
			</svg>

		</>
	)
}


export const ContactIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.95 21C17.8667 21 15.8083 20.5458 13.775 19.6375C11.7417 18.7292 9.89167 17.4417 8.225 15.775C6.55833 14.1083 5.27083 12.2583 4.3625 10.225C3.45417 8.19167 3 6.13333 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07917 8.725 3.2375C8.90833 3.39583 9.01667 3.58333 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.70417 12.1125 8.1625 12.6875C8.62083 13.2625 9.125 13.8167 9.675 14.35C10.1917 14.8667 10.7333 15.3458 11.3 15.7875C11.8667 16.2292 12.4667 16.6333 13.1 17L15.45 14.65C15.6 14.5 15.7958 14.3875 16.0375 14.3125C16.2792 14.2375 16.5167 14.2167 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1375 20.775 15.3125C20.925 15.4875 21 15.6833 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21Z"
				fill="white" />
		</svg>

	)
}


export const SettingIcon = () => {
	return (
		<svg width="20" height="19" viewBox="0 0 20 19" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.06984 17.4167C8.71359 17.4167 8.40682 17.2979 8.14952 17.0604C7.89223 16.8229 7.7372 16.5326 7.68442 16.1896L7.5063 14.8833C7.33477 14.8174 7.17314 14.7382 7.0214 14.6458C6.86966 14.5535 6.72123 14.4545 6.57609 14.349L5.349 14.8635C5.01914 15.0087 4.68928 15.0219 4.35942 14.9031C4.02956 14.7844 3.77227 14.5733 3.58755 14.2698L2.65734 12.6469C2.47262 12.3434 2.41984 12.0201 2.499 11.6771C2.57817 11.334 2.7563 11.0503 3.03338 10.826L4.08234 10.0344C4.06914 9.94201 4.06255 9.85295 4.06255 9.76718V9.23281C4.06255 9.14704 4.06914 9.05798 4.08234 8.96562L3.03338 8.17395C2.7563 7.94965 2.57817 7.66597 2.499 7.32291C2.41984 6.97986 2.47262 6.65659 2.65734 6.35312L3.58755 4.7302C3.77227 4.42673 4.02956 4.21562 4.35942 4.09687C4.68928 3.97812 5.01914 3.99131 5.349 4.13645L6.57609 4.65104C6.72123 4.54548 6.87296 4.44652 7.0313 4.35416C7.18963 4.2618 7.34796 4.18263 7.5063 4.11666L7.68442 2.81041C7.7372 2.46736 7.89223 2.17708 8.14952 1.93958C8.40682 1.70208 8.71359 1.58333 9.06984 1.58333H10.9303C11.2865 1.58333 11.5933 1.70208 11.8506 1.93958C12.1079 2.17708 12.2629 2.46736 12.3157 2.81041L12.4938 4.11666C12.6653 4.18263 12.827 4.2618 12.9787 4.35416C13.1304 4.44652 13.2789 4.54548 13.424 4.65104L14.6511 4.13645C14.9809 3.99131 15.3108 3.97812 15.6407 4.09687C15.9705 4.21562 16.2278 4.42673 16.4125 4.7302L17.3428 6.35312C17.5275 6.65659 17.5803 6.97986 17.5011 7.32291C17.4219 7.66597 17.2438 7.94965 16.9667 8.17395L15.9178 8.96562C15.9309 9.05798 15.9375 9.14704 15.9375 9.23281V9.76718C15.9375 9.85295 15.9244 9.94201 15.898 10.0344L16.9469 10.826C17.224 11.0503 17.4021 11.334 17.4813 11.6771C17.5605 12.0201 17.5077 12.3434 17.323 12.6469L16.373 14.2698C16.1882 14.5733 15.9309 14.7844 15.6011 14.9031C15.2712 15.0219 14.9414 15.0087 14.6115 14.8635L13.424 14.349C13.2789 14.4545 13.1271 14.5535 12.9688 14.6458C12.8105 14.7382 12.6521 14.8174 12.4938 14.8833L12.3157 16.1896C12.2629 16.5326 12.1079 16.8229 11.8506 17.0604C11.5933 17.2979 11.2865 17.4167 10.9303 17.4167H9.06984ZM10.0396 12.2708C10.8049 12.2708 11.458 12.0003 11.999 11.4594C12.54 10.9184 12.8105 10.2653 12.8105 9.49999C12.8105 8.73472 12.54 8.08159 11.999 7.54062C11.458 6.99965 10.8049 6.72916 10.0396 6.72916C9.26116 6.72916 8.60473 6.99965 8.07036 7.54062C7.53598 8.08159 7.2688 8.73472 7.2688 9.49999C7.2688 10.2653 7.53598 10.9184 8.07036 11.4594C8.60473 12.0003 9.26116 12.2708 10.0396 12.2708Z"
				fill="#181818" />
		</svg>


	)
}

export const SwitchPharmacyIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.82505 17L7.72505 18.9C7.92505 19.1 8.02088 19.3333 8.01255 19.6C8.00422 19.8667 7.90005 20.1 7.70005 20.3C7.50005 20.4833 7.26672 20.5792 7.00005 20.5875C6.73338 20.5958 6.50005 20.5 6.30005 20.3L2.70005 16.7C2.60005 16.6 2.52922 16.4917 2.48755 16.375C2.44588 16.2583 2.42505 16.1333 2.42505 16C2.42505 15.8667 2.44588 15.7417 2.48755 15.625C2.52922 15.5083 2.60005 15.4 2.70005 15.3L6.30005 11.7C6.48338 11.5167 6.71255 11.425 6.98755 11.425C7.26255 11.425 7.50005 11.5167 7.70005 11.7C7.90005 11.9 8.00005 12.1375 8.00005 12.4125C8.00005 12.6875 7.90005 12.925 7.70005 13.125L5.82505 15H20C20.2834 15 20.5209 15.0958 20.7126 15.2875C20.9042 15.4792 21 15.7167 21 16C21 16.2833 20.9042 16.5208 20.7126 16.7125C20.5209 16.9042 20.2834 17 20 17H5.82505ZM18.175 9H4.00005C3.71672 9 3.47922 8.90417 3.28755 8.7125C3.09588 8.52083 3.00005 8.28333 3.00005 8C3.00005 7.71667 3.09588 7.47917 3.28755 7.2875C3.47922 7.09583 3.71672 7 4.00005 7H18.175L16.2751 5.1C16.0751 4.9 15.9792 4.66667 15.9875 4.4C15.9959 4.13333 16.1 3.9 16.3 3.7C16.5001 3.51667 16.7334 3.42083 17.0001 3.4125C17.2667 3.40417 17.5001 3.5 17.7001 3.7L21.3001 7.3C21.4001 7.4 21.4709 7.50833 21.5126 7.625C21.5542 7.74167 21.5751 7.86667 21.5751 8C21.5751 8.13333 21.5542 8.25833 21.5126 8.375C21.4709 8.49167 21.4001 8.6 21.3001 8.7L17.7001 12.3C17.5167 12.4833 17.2875 12.575 17.0126 12.575C16.7375 12.575 16.5001 12.4833 16.3 12.3C16.1 12.1 16 11.8625 16 11.5875C16 11.3125 16.1 11.075 16.3 10.875L18.175 9Z"
				fill="white" />
		</svg>


	)
}

export const MissedDispenseIcon = () => {
	return (
		<svg
			className="relative"
			width="20"
			height="17"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
		>
			<path strokeLinecap="round"
				strokeLinejoin="round"
				d="M6 18 18 6M6 6l12 12" />
		</svg>

	)
}

export const SearchIcon = () => {
	return (
		<svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
				strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
		</svg>

	)
}

export const PendingDispenseIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6 20C5.16667 20 4.45833 19.7083 3.875 19.125C3.29167 18.5417 3 17.8333 3 17H2C1.71667 17 1.47917 16.9042 1.2875 16.7125C1.09583 16.5208 1 16.2833 1 16V6C1 5.45 1.19583 4.97917 1.5875 4.5875C1.97917 4.19583 2.45 4 3 4H15C15.55 4 16.0208 4.19583 16.4125 4.5875C16.8042 4.97917 17 5.45 17 6V8H19C19.3167 8 19.6167 8.07084 19.9 8.2125C20.1833 8.35417 20.4167 8.55 20.6 8.8L22.8 11.725C22.8667 11.8083 22.9167 11.9 22.95 12C22.9833 12.1 23 12.2083 23 12.325V16C23 16.2833 22.9042 16.5208 22.7125 16.7125C22.5208 16.9042 22.2833 17 22 17H21C21 17.8333 20.7083 18.5417 20.125 19.125C19.5417 19.7083 18.8333 20 18 20C17.1667 20 16.4583 19.7083 15.875 19.125C15.2917 18.5417 15 17.8333 15 17H9C9 17.8333 8.70834 18.5417 8.125 19.125C7.54167 19.7083 6.83333 20 6 20ZM6 18C6.28333 18 6.52083 17.9042 6.7125 17.7125C6.90417 17.5208 7 17.2833 7 17C7 16.7167 6.90417 16.4792 6.7125 16.2875C6.52083 16.0958 6.28333 16 6 16C5.71667 16 5.47917 16.0958 5.2875 16.2875C5.09583 16.4792 5 16.7167 5 17C5 17.2833 5.09583 17.5208 5.2875 17.7125C5.47917 17.9042 5.71667 18 6 18ZM18 18C18.2833 18 18.5208 17.9042 18.7125 17.7125C18.9042 17.5208 19 17.2833 19 17C19 16.7167 18.9042 16.4792 18.7125 16.2875C18.5208 16.0958 18.2833 16 18 16C17.7167 16 17.4792 16.0958 17.2875 16.2875C17.0958 16.4792 17 16.7167 17 17C17 17.2833 17.0958 17.5208 17.2875 17.7125C17.4792 17.9042 17.7167 18 18 18ZM17 13H21.25L19 10H17V13Z"
				fill="white" />
		</svg>

	)
}


export const PendingSignatures = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-white">
			<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
		</svg>
	)
}

export const CrossIcon = () => {
	return (
		<>
			<svg style={{ color: 'white' }} width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
				<path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" fill="white" />
			</svg>

		</>
	)
}


export const UserDispenseIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-white">
			<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
		</svg>


	)
}

export const DownDropdowIcon = () => {
	return (
		<svg
			className="relative mt-2"
			width="20"
			height="18"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			// style={{rotate:''}}
			stroke="currentColor"
		>
			<path strokeLinecap="round"
				strokeLinejoin="round"
				d="m19.5 8.25-7.5 7.5-7.5-7.5" />
		</svg>

	)
}

export const UpDropdowIcon = () => {
	return (
		<svg
			className="relative mt-2"
			width="20"
			height="18"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
		>
			<path strokeLinecap="round"
				strokeLinejoin="round"
				d="m4.5 15.75 7.5-7.5 7.5 7.5" />
		</svg>


	)
}

export const EmailIcon = () => {
	return (
		<svg
			style={{ marginTop: '2.5px' }}
			className="w-4 h-4 ml-2 mr-4  text-gray-500 "
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 16"
		>
			<path
				d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
			<path
				d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
		</svg>
	)
}

export const PasswordIcon = () => {
	return (
		<svg
			className="w-5 h-5 ml-2 mr-4 text-gray-500 "
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 21">
			<path
				d="M4.99998 18.8333C4.54165 18.8333 4.14929 18.6701 3.8229 18.3438C3.49651 18.0174 3.33331 17.625 3.33331 17.1667V8.83334C3.33331 8.375 3.49651 7.98264 3.8229 7.65625C4.14929 7.32986 4.54165 7.16667 4.99998 7.16667H5.83331V5.5C5.83331 4.34722 6.23956 3.36459 7.05206 2.55209C7.86456 1.73959 8.8472 1.33334 9.99998 1.33334C11.1528 1.33334 12.1354 1.73959 12.9479 2.55209C13.7604 3.36459 14.1666 4.34722 14.1666 5.5V7.16667H15C15.4583 7.16667 15.8507 7.32986 16.1771 7.65625C16.5035 7.98264 16.6666 8.375 16.6666 8.83334V17.1667C16.6666 17.625 16.5035 18.0174 16.1771 18.3438C15.8507 18.6701 15.4583 18.8333 15 18.8333H4.99998ZM9.99998 14.6667C10.4583 14.6667 10.8507 14.5035 11.1771 14.1771C11.5035 13.8507 11.6666 13.4583 11.6666 13C11.6666 12.5417 11.5035 12.1493 11.1771 11.8229C10.8507 11.4965 10.4583 11.3333 9.99998 11.3333C9.54165 11.3333 9.14928 11.4965 8.8229 11.8229C8.49651 12.1493 8.33331 12.5417 8.33331 13C8.33331 13.4583 8.49651 13.8507 8.8229 14.1771C9.14928 14.5035 9.54165 14.6667 9.99998 14.6667ZM7.49998 7.16667H12.5V5.5C12.5 4.80556 12.2569 4.21528 11.7708 3.72917C11.2847 3.24306 10.6944 3 9.99998 3C9.30553 3 8.71526 3.24306 8.22915 3.72917C7.74303 4.21528 7.49998 4.80556 7.49998 5.5V7.16667Z" />
		</svg>
	)
}

export const PasscodeIcon = () => {
	return (
		<svg
			className="w-5 h-5 ml-2 mr-4 text-gray-500 "
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 21">
			<path
				d="M5.83331 13C5.13887 13 4.54859 12.7569 4.06248 12.2708C3.57637 11.7847 3.33331 11.1944 3.33331 10.5C3.33331 9.80556 3.57637 9.21528 4.06248 8.72917C4.54859 8.24306 5.13887 8 5.83331 8C6.52776 8 7.11804 8.24306 7.60415 8.72917C8.09026 9.21528 8.33331 9.80556 8.33331 10.5C8.33331 11.1944 8.09026 11.7847 7.60415 12.2708C7.11804 12.7569 6.52776 13 5.83331 13ZM5.83331 15.5C6.90276 15.5 7.86804 15.1944 8.72915 14.5833C9.59026 13.9722 10.1944 13.1667 10.5416 12.1667H10.8333L11.9166 13.25C12 13.3333 12.0903 13.3924 12.1875 13.4271C12.2847 13.4618 12.3889 13.4792 12.5 13.4792C12.6111 13.4792 12.7153 13.4618 12.8125 13.4271C12.9097 13.3924 13 13.3333 13.0833 13.25L14.1666 12.1667L15.625 13.3125C15.7083 13.3819 15.8021 13.434 15.9062 13.4688C16.0104 13.5035 16.118 13.5139 16.2291 13.5C16.3403 13.4861 16.441 13.4549 16.5312 13.4062C16.6215 13.3576 16.7014 13.2917 16.7708 13.2083L18.6458 11.0625C18.7153 10.9792 18.7673 10.8889 18.8021 10.7917C18.8368 10.6944 18.8541 10.5903 18.8541 10.4792C18.8541 10.3681 18.8333 10.2674 18.7916 10.1771C18.75 10.0868 18.6944 10.0069 18.625 9.9375L17.7708 9.08333C17.6875 9 17.5937 8.9375 17.4896 8.89583C17.3854 8.85417 17.2778 8.83333 17.1666 8.83333H10.5416C10.2083 7.88889 9.62151 7.09722 8.78123 6.45833C7.94095 5.81944 6.95831 5.5 5.83331 5.5C4.44442 5.5 3.26387 5.98611 2.29165 6.95833C1.31942 7.93056 0.833313 9.11111 0.833313 10.5C0.833313 11.8889 1.31942 13.0694 2.29165 14.0417C3.26387 15.0139 4.44442 15.5 5.83331 15.5Z" />
		</svg>
	)
}

export const CloseEyeIcon = () => {
	return (
		<svg className="w-4 h-4 text-gray-500"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 512" >
			<path fill="currentColor"
				d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z">
			</path>
		</svg >
	)
}

export const OpenEyeIcon = () => {
	return (
		<svg className="w-4 h-4 text-gray-500" fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 576 512" >
			<path fill="currentColor"
				d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z">
			</path>
		</svg >


	)
}

export const SettingIcon2 = () => {
	return (
		<svg
			width="15"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.825 22C10.375 22 9.98748 21.85 9.66248 21.55C9.33748 21.25 9.14165 20.8833 9.07498 20.45L8.84998 18.8C8.63331 18.7167 8.42915 18.6167 8.23748 18.5C8.04581 18.3833 7.85831 18.2583 7.67498 18.125L6.12498 18.775C5.70831 18.9583 5.29165 18.975 4.87498 18.825C4.45831 18.675 4.13331 18.4083 3.89998 18.025L2.72498 15.975C2.49165 15.5917 2.42498 15.1833 2.52498 14.75C2.62498 14.3167 2.84998 13.9583 3.19998 13.675L4.52498 12.675C4.50831 12.5583 4.49998 12.4458 4.49998 12.3375V11.6625C4.49998 11.5542 4.50831 11.4417 4.52498 11.325L3.19998 10.325C2.84998 10.0417 2.62498 9.68333 2.52498 9.25C2.42498 8.81667 2.49165 8.40833 2.72498 8.025L3.89998 5.975C4.13331 5.59167 4.45831 5.325 4.87498 5.175C5.29165 5.025 5.70831 5.04167 6.12498 5.225L7.67498 5.875C7.85831 5.74167 8.04998 5.61667 8.24998 5.5C8.44998 5.38333 8.64998 5.28333 8.84998 5.2L9.07498 3.55C9.14165 3.11667 9.33748 2.75 9.66248 2.45C9.98748 2.15 10.375 2 10.825 2H13.175C13.625 2 14.0125 2.15 14.3375 2.45C14.6625 2.75 14.8583 3.11667 14.925 3.55L15.15 5.2C15.3666 5.28333 15.5708 5.38333 15.7625 5.5C15.9541 5.61667 16.1416 5.74167 16.325 5.875L17.875 5.225C18.2916 5.04167 18.7083 5.025 19.125 5.175C19.5416 5.325 19.8666 5.59167 20.1 5.975L21.275 8.025C21.5083 8.40833 21.575 8.81667 21.475 9.25C21.375 9.68333 21.15 10.0417 20.8 10.325L19.475 11.325C19.4916 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L20.775 13.675C21.125 13.9583 21.35 14.3167 21.45 14.75C21.55 15.1833 21.4833 15.5917 21.25 15.975L20.05 18.025C19.8166 18.4083 19.4916 18.675 19.075 18.825C18.6583 18.975 18.2416 18.9583 17.825 18.775L16.325 18.125C16.1416 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.925 20.45C14.8583 20.8833 14.6625 21.25 14.3375 21.55C14.0125 21.85 13.625 22 13.175 22H10.825ZM12.05 15.5C13.0166 15.5 13.8416 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8416 8.84167 13.0166 8.5 12.05 8.5C11.0666 8.5 10.2375 8.84167 9.56248 9.525C8.88748 10.2083 8.54998 11.0333 8.54998 12C8.54998 12.9667 8.88748 13.7917 9.56248 14.475C10.2375 15.1583 11.0666 15.5 12.05 15.5Z"
				fill="white" />
		</svg>
	)
}

export const HomeInIcon = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H11C11.2833 3 11.5208 3.09583 11.7125 3.2875C11.9042 3.47917 12 3.71667 12 4C12 4.28333 11.9042 4.52083 11.7125 4.7125C11.5208 4.90417 11.2833 5 11 5H5V19H11C11.2833 19 11.5208 19.0958 11.7125 19.2875C11.9042 19.4792 12 19.7167 12 20C12 20.2833 11.9042 20.5208 11.7125 20.7125C11.5208 20.9042 11.2833 21 11 21H5ZM17.175 13H10C9.71667 13 9.47917 12.9042 9.2875 12.7125C9.09583 12.5208 9 12.2833 9 12C9 11.7167 9.09583 11.4792 9.2875 11.2875C9.47917 11.0958 9.71667 11 10 11H17.175L15.3 9.125C15.1167 8.94167 15.025 8.71667 15.025 8.45C15.025 8.18333 15.1167 7.95 15.3 7.75C15.4833 7.55 15.7167 7.44583 16 7.4375C16.2833 7.42917 16.525 7.525 16.725 7.725L20.3 11.3C20.5 11.5 20.6 11.7333 20.6 12C20.6 12.2667 20.5 12.5 20.3 12.7L16.725 16.275C16.525 16.475 16.2875 16.5708 16.0125 16.5625C15.7375 16.5542 15.5 16.45 15.3 16.25C15.1167 16.05 15.0292 15.8125 15.0375 15.5375C15.0458 15.2625 15.1417 15.0333 15.325 14.85L17.175 13Z"
				fill="white" />
		</svg>
	)
}

export const PatientConsent = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C12.1833 13 12.3625 13.0042 12.5375 13.0125C12.7125 13.0208 12.8917 13.0333 13.075 13.05C13.3417 13.0833 13.5625 13.1958 13.7375 13.3875C13.9125 13.5792 14 13.8083 14 14.075V19C14 19.2833 13.9042 19.5208 13.7125 19.7125C13.5208 19.9042 13.2833 20 13 20H6ZM12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM18 19H17C16.7167 19 16.4792 18.9042 16.2875 18.7125C16.0958 18.5208 16 18.2833 16 18V14C16 13.7167 16.0958 13.4792 16.2875 13.2875C16.4792 13.0958 16.7167 13 17 13H20.775C21.0583 13 21.275 13.1167 21.425 13.35C21.575 13.5833 21.5833 13.825 21.45 14.075L20 17H20.7C20.9833 17 21.1958 17.125 21.3375 17.375C21.4792 17.625 21.4833 17.875 21.35 18.125L18.475 23.175C18.4083 23.2917 18.3125 23.3333 18.1875 23.3C18.0625 23.2667 18 23.1833 18 23.05V19Z"
				fill="white" />
		</svg>
	)
}

export const ProfileSetting = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.02106 18.3333C8.64606 18.3333 8.32314 18.2083 8.05231 17.9583C7.78148 17.7083 7.61828 17.4028 7.56273 17.0417L7.37523 15.6667C7.19467 15.5972 7.02453 15.5139 6.86481 15.4167C6.70509 15.3194 6.54884 15.2153 6.39606 15.1042L5.10439 15.6458C4.75717 15.7986 4.40995 15.8125 4.06273 15.6875C3.71551 15.5625 3.44467 15.3403 3.25023 15.0208L2.27106 13.3125C2.07662 12.9931 2.02106 12.6528 2.10439 12.2917C2.18773 11.9306 2.37523 11.6319 2.66689 11.3958L3.77106 10.5625C3.75717 10.4653 3.75023 10.3715 3.75023 10.2813V9.71875C3.75023 9.62847 3.75717 9.53472 3.77106 9.4375L2.66689 8.60417C2.37523 8.36806 2.18773 8.06945 2.10439 7.70833C2.02106 7.34722 2.07662 7.00695 2.27106 6.6875L3.25023 4.97917C3.44467 4.65972 3.71551 4.4375 4.06273 4.3125C4.40995 4.1875 4.75717 4.20139 5.10439 4.35417L6.39606 4.89583C6.54884 4.78472 6.70856 4.68056 6.87523 4.58333C7.04189 4.48611 7.20856 4.40278 7.37523 4.33333L7.56273 2.95833C7.61828 2.59722 7.78148 2.29167 8.05231 2.04167C8.32314 1.79167 8.64606 1.66667 9.02106 1.66667H10.9794C11.3544 1.66667 11.6773 1.79167 11.9481 2.04167C12.219 2.29167 12.3822 2.59722 12.4377 2.95833L12.6252 4.33333C12.8058 4.40278 12.9759 4.48611 13.1356 4.58333C13.2954 4.68056 13.4516 4.78472 13.6044 4.89583L14.8961 4.35417C15.2433 4.20139 15.5905 4.1875 15.9377 4.3125C16.2849 4.4375 16.5558 4.65972 16.7502 4.97917L17.7294 6.6875C17.9238 7.00695 17.9794 7.34722 17.8961 7.70833C17.8127 8.06945 17.6252 8.36806 17.3336 8.60417L16.2294 9.4375C16.2433 9.53472 16.2502 9.62847 16.2502 9.71875V10.2813C16.2502 10.3715 16.2363 10.4653 16.2086 10.5625L17.3127 11.3958C17.6044 11.6319 17.7919 11.9306 17.8752 12.2917C17.9586 12.6528 17.903 12.9931 17.7086 13.3125L16.7086 15.0208C16.5141 15.3403 16.2433 15.5625 15.8961 15.6875C15.5488 15.8125 15.2016 15.7986 14.8544 15.6458L13.6044 15.1042C13.4516 15.2153 13.2919 15.3194 13.1252 15.4167C12.9586 15.5139 12.7919 15.5972 12.6252 15.6667L12.4377 17.0417C12.3822 17.4028 12.219 17.7083 11.9481 17.9583C11.6773 18.2083 11.3544 18.3333 10.9794 18.3333H9.02106ZM10.0419 12.9167C10.8474 12.9167 11.5349 12.6319 12.1044 12.0625C12.6738 11.4931 12.9586 10.8056 12.9586 10C12.9586 9.19445 12.6738 8.50695 12.1044 7.9375C11.5349 7.36806 10.8474 7.08333 10.0419 7.08333C9.22245 7.08333 8.53148 7.36806 7.96898 7.9375C7.40648 8.50695 7.12523 9.19445 7.12523 10C7.12523 10.8056 7.40648 11.4931 7.96898 12.0625C8.53148 12.6319 9.22245 12.9167 10.0419 12.9167Z"
				fill="white" />
		</svg>
	)
}

export const CommentIcon1 = () => {
	return (
		<svg width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 13.2125C10.8996 13.2125 10.8059 13.1969 10.7184 13.1657C10.6309 13.1344 10.5496 13.0813 10.4746 13.0063L7.02461 9.5563C6.88711 9.4188 6.81836 9.2438 6.81836 9.0313C6.81836 8.8188 6.88711 8.6438 7.02461 8.5063C7.16211 8.3688 7.33711 8.30005 7.54961 8.30005C7.76211 8.30005 7.93711 8.3688 8.07461 8.5063L10.9996 11.4313L13.9246 8.5063C14.0621 8.3688 14.2371 8.30005 14.4496 8.30005C14.6621 8.30005 14.8371 8.3688 14.9746 8.5063C15.1121 8.6438 15.1809 8.8188 15.1809 9.0313C15.1809 9.2438 15.1121 9.4188 14.9746 9.5563L11.5246 13.0063C11.4496 13.0813 11.3684 13.1344 11.2809 13.1657C11.1934 13.1969 11.0996 13.2125 10.9996 13.2125Z"
				fill="#1B2336" />
		</svg>

	)
}
export const CommentIcon2 = () => {
	return (
		<svg width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 8.78745C10.8996 8.78745 10.8059 8.80308 10.7184 8.83433C10.6309 8.86558 10.5496 8.9187 10.4746 8.9937L7.02461 12.4437C6.88711 12.5812 6.81836 12.7562 6.81836 12.9687C6.81836 13.1812 6.88711 13.3562 7.02461 13.4937C7.16211 13.6312 7.33711 13.7 7.54961 13.7C7.76211 13.7 7.93711 13.6312 8.07461 13.4937L10.9996 10.5687L13.9246 13.4937C14.0621 13.6312 14.2371 13.7 14.4496 13.7C14.6621 13.7 14.8371 13.6312 14.9746 13.4937C15.1121 13.3562 15.1809 13.1812 15.1809 12.9687C15.1809 12.7562 15.1121 12.5812 14.9746 12.4437L11.5246 8.9937C11.4496 8.9187 11.3684 8.86558 11.2809 8.83433C11.1934 8.80308 11.0996 8.78745 10.9996 8.78745Z"
				fill="#1B2336" />
		</svg>

	)
}

export const PatientSignatureIcon1 = () => {
	return (
		<svg width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 13.2125C10.8996 13.2125 10.8059 13.1969 10.7184 13.1657C10.6309 13.1344 10.5496 13.0813 10.4746 13.0063L7.02461 9.5563C6.88711 9.4188 6.81836 9.2438 6.81836 9.0313C6.81836 8.8188 6.88711 8.6438 7.02461 8.5063C7.16211 8.3688 7.33711 8.30005 7.54961 8.30005C7.76211 8.30005 7.93711 8.3688 8.07461 8.5063L10.9996 11.4313L13.9246 8.5063C14.0621 8.3688 14.2371 8.30005 14.4496 8.30005C14.6621 8.30005 14.8371 8.3688 14.9746 8.5063C15.1121 8.6438 15.1809 8.8188 15.1809 9.0313C15.1809 9.2438 15.1121 9.4188 14.9746 9.5563L11.5246 13.0063C11.4496 13.0813 11.3684 13.1344 11.2809 13.1657C11.1934 13.1969 11.0996 13.2125 10.9996 13.2125Z"
				fill="#1B2336" />
		</svg>
	)
}

export const PatientSignatureIcon2 = () => {
	return (
		<svg width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 8.78745C10.8996 8.78745 10.8059 8.80308 10.7184 8.83433C10.6309 8.86558 10.5496 8.9187 10.4746 8.9937L7.02461 12.4437C6.88711 12.5812 6.81836 12.7562 6.81836 12.9687C6.81836 13.1812 6.88711 13.3562 7.02461 13.4937C7.16211 13.6312 7.33711 13.7 7.54961 13.7C7.76211 13.7 7.93711 13.6312 8.07461 13.4937L10.9996 10.5687L13.9246 13.4937C14.0621 13.6312 14.2371 13.7 14.4496 13.7C14.6621 13.7 14.8371 13.6312 14.9746 13.4937C15.1121 13.3562 15.1809 13.1812 15.1809 12.9687C15.1809 12.7562 15.1121 12.5812 14.9746 12.4437L11.5246 8.9937C11.4496 8.9187 11.3684 8.86558 11.2809 8.83433C11.1934 8.80308 11.0996 8.78745 10.9996 8.78745Z"
				fill="#1B2336" />
		</svg>
	)
}

export const ClearPatientSignatureIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.9379 13.5H16.5004V15H11.4379L12.9379 13.5ZM3.56289 15L1.96914 13.4062C1.68164 13.1188 1.53477 12.7625 1.52852 12.3375C1.52227 11.9125 1.66289 11.55 1.95039 11.25L10.2004 2.7C10.4879 2.4 10.841 2.25 11.2598 2.25C11.6785 2.25 12.0316 2.39375 12.3191 2.68125L16.0504 6.4125C16.3379 6.7 16.4816 7.05625 16.4816 7.48125C16.4816 7.90625 16.3379 8.2625 16.0504 8.55L9.7504 15H3.56289Z"
				fill="black" />
		</svg>
	)
}

export const PharmacistSignatureIcon1 = () => {
	return (
		<svg x-show="!show" width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 13.2125C10.8996 13.2125 10.8059 13.1969 10.7184 13.1657C10.6309 13.1344 10.5496 13.0813 10.4746 13.0063L7.02461 9.5563C6.88711 9.4188 6.81836 9.2438 6.81836 9.0313C6.81836 8.8188 6.88711 8.6438 7.02461 8.5063C7.16211 8.3688 7.33711 8.30005 7.54961 8.30005C7.76211 8.30005 7.93711 8.3688 8.07461 8.5063L10.9996 11.4313L13.9246 8.5063C14.0621 8.3688 14.2371 8.30005 14.4496 8.30005C14.6621 8.30005 14.8371 8.3688 14.9746 8.5063C15.1121 8.6438 15.1809 8.8188 15.1809 9.0313C15.1809 9.2438 15.1121 9.4188 14.9746 9.5563L11.5246 13.0063C11.4496 13.0813 11.3684 13.1344 11.2809 13.1657C11.1934 13.1969 11.0996 13.2125 10.9996 13.2125Z"
				fill="#1B2336" />
		</svg>
	)
}

export const PharmacistSignatureIcon2 = () => {
	return (
		<svg x-show="show" width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 8.78745C10.8996 8.78745 10.8059 8.80308 10.7184 8.83433C10.6309 8.86558 10.5496 8.9187 10.4746 8.9937L7.02461 12.4437C6.88711 12.5812 6.81836 12.7562 6.81836 12.9687C6.81836 13.1812 6.88711 13.3562 7.02461 13.4937C7.16211 13.6312 7.33711 13.7 7.54961 13.7C7.76211 13.7 7.93711 13.6312 8.07461 13.4937L10.9996 10.5687L13.9246 13.4937C14.0621 13.6312 14.2371 13.7 14.4496 13.7C14.6621 13.7 14.8371 13.6312 14.9746 13.4937C15.1121 13.3562 15.1809 13.1812 15.1809 12.9687C15.1809 12.7562 15.1121 12.5812 14.9746 12.4437L11.5246 8.9937C11.4496 8.9187 11.3684 8.86558 11.2809 8.83433C11.1934 8.80308 11.0996 8.78745 10.9996 8.78745Z"
				fill="#1B2336" />
		</svg>
	)
}

export const DropdownBoxIcon1 = () => {
	return (
		<svg width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 13.2125C10.8996 13.2125 10.8059 13.1969 10.7184 13.1657C10.6309 13.1344 10.5496 13.0813 10.4746 13.0063L7.02461 9.5563C6.88711 9.4188 6.81836 9.2438 6.81836 9.0313C6.81836 8.8188 6.88711 8.6438 7.02461 8.5063C7.16211 8.3688 7.33711 8.30005 7.54961 8.30005C7.76211 8.30005 7.93711 8.3688 8.07461 8.5063L10.9996 11.4313L13.9246 8.5063C14.0621 8.3688 14.2371 8.30005 14.4496 8.30005C14.6621 8.30005 14.8371 8.3688 14.9746 8.5063C15.1121 8.6438 15.1809 8.8188 15.1809 9.0313C15.1809 9.2438 15.1121 9.4188 14.9746 9.5563L11.5246 13.0063C11.4496 13.0813 11.3684 13.1344 11.2809 13.1657C11.1934 13.1969 11.0996 13.2125 10.9996 13.2125Z"
				fill="#1B2336" />
		</svg>
	)
}

export const DropdownBoxIcon2 = () => {
	return (
		<svg x-show="showInfo" width="22" height="22"
			viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.9996 8.78745C10.8996 8.78745 10.8059 8.80308 10.7184 8.83433C10.6309 8.86558 10.5496 8.9187 10.4746 8.9937L7.02461 12.4437C6.88711 12.5812 6.81836 12.7562 6.81836 12.9687C6.81836 13.1812 6.88711 13.3562 7.02461 13.4937C7.16211 13.6312 7.33711 13.7 7.54961 13.7C7.76211 13.7 7.93711 13.6312 8.07461 13.4937L10.9996 10.5687L13.9246 13.4937C14.0621 13.6312 14.2371 13.7 14.4496 13.7C14.6621 13.7 14.8371 13.6312 14.9746 13.4937C15.1121 13.3562 15.1809 13.1812 15.1809 12.9687C15.1809 12.7562 15.1121 12.5812 14.9746 12.4437L11.5246 8.9937C11.4496 8.9187 11.3684 8.86558 11.2809 8.83433C11.1934 8.80308 11.0996 8.78745 10.9996 8.78745Z"
				fill="#1B2336" />
		</svg>
	)
}

export const MapIcon = () => {
	return (
		<svg width="14" height="18" viewBox="0 0 14 18" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_5182_8964)">
				<path fillRule="evenodd" clipRule="evenodd"
					d="M8.89784 0.292626C8.29903 0.103464 7.6621 0 7.00066 0C5.0708 0 3.34377 0.872371 2.19238 2.24284L5.15925 4.73883L8.89779 0.292572L8.89784 0.292626Z"
					fill="#1A73E8" />
				<path fillRule="evenodd" clipRule="evenodd"
					d="M2.1909 2.2428C1.27361 3.3343 0.719727 4.74289 0.719727 6.27941C0.719727 7.46072 0.955167 8.41749 1.34165 9.2749L5.15778 4.73879L2.1909 2.2428Z"
					fill="#EA4335" />
				<path fillRule="evenodd" clipRule="evenodd"
					d="M7.00095 3.87875C8.3279 3.87875 9.40304 4.95389 9.40304 6.28083C9.40304 6.87148 9.18936 7.41316 8.83555 7.83096C8.83555 7.83096 10.7327 5.57451 12.5741 3.38605C11.8133 1.92303 10.4945 0.797503 8.89949 0.292603L5.1582 4.73886C5.59917 4.2122 6.26061 3.87875 7.00095 3.87875Z"
					fill="#4285F4" />
				<path fillRule="evenodd" clipRule="evenodd"
					d="M7.00068 8.68148C5.67374 8.68148 4.59859 7.60634 4.59859 6.2794C4.59859 5.6928 4.80952 5.15523 5.15793 4.73743L1.3418 9.27489C1.99369 10.7216 3.07838 11.8825 4.19575 13.3455L8.83387 7.83087C8.39426 8.35079 7.73557 8.68148 7.00068 8.68148Z"
					fill="#FBBC04" />
				<path fillRule="evenodd" clipRule="evenodd"
					d="M8.74288 14.8508C10.8374 11.575 13.2803 10.0875 13.2803 6.27949C13.2803 5.23561 13.0244 4.25168 12.574 3.38611L4.19727 13.3456C4.55248 13.8111 4.91039 14.3064 5.26015 14.8522C6.53401 16.8202 6.18015 18.0001 7.00219 18.0001C7.82148 18.0001 7.46897 16.8188 8.74288 14.8508Z"
					fill="#34A853" />
			</g>
			<defs>
				<clipPath id="clip0_5182_8964">
					<rect width="12.5603" height="18" fill="white"
						transform="translate(0.719727)" />
				</clipPath>
			</defs>
		</svg>
	)
}

export const PhoneIcon = ({ color = '#1BAC25' }) => {
	return (
		<svg width="18" height="18"
			viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.9625 15.75C13.4 15.75 11.8563 15.4094 10.3313 14.7281C8.80625 14.0469 7.41875 13.0813 6.16875 11.8313C4.91875 10.5813 3.95312 9.19375 3.27188 7.66875C2.59063 6.14375 2.25 4.6 2.25 3.0375C2.25 2.8125 2.325 2.625 2.475 2.475C2.625 2.325 2.8125 2.25 3.0375 2.25H6.075C6.25 2.25 6.40625 2.30937 6.54375 2.42813C6.68125 2.54688 6.7625 2.6875 6.7875 2.85L7.275 5.475C7.3 5.675 7.29375 5.84375 7.25625 5.98125C7.21875 6.11875 7.15 6.2375 7.05 6.3375L5.23125 8.175C5.48125 8.6375 5.77813 9.08438 6.12188 9.51563C6.46563 9.94688 6.84375 10.3625 7.25625 10.7625C7.64375 11.15 8.05 11.5094 8.475 11.8406C8.9 12.1719 9.35 12.475 9.825 12.75L11.5875 10.9875C11.7 10.875 11.8469 10.7906 12.0281 10.7344C12.2094 10.6781 12.3875 10.6625 12.5625 10.6875L15.15 11.2125C15.325 11.2625 15.4688 11.3531 15.5813 11.4844C15.6938 11.6156 15.75 11.7625 15.75 11.925V14.9625C15.75 15.1875 15.675 15.375 15.525 15.525C15.375 15.675 15.1875 15.75 14.9625 15.75Z"
				fill={color} />
		</svg>
	)
}

export const LocationIcon = () => {
	return (
		<svg className="w-7 h-7" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9 15.9938C8.825 15.9938 8.65 15.9625 8.475 15.9C8.3 15.8375 8.14375 15.7438 8.00625 15.6188C7.19375 14.8688 6.475 14.1375 5.85 13.425C5.225 12.7125 4.70313 12.0219 4.28438 11.3531C3.86563 10.6844 3.54688 10.0406 3.32812 9.42188C3.10938 8.80313 3 8.2125 3 7.65C3 5.775 3.60312 4.28125 4.80938 3.16875C6.01563 2.05625 7.4125 1.5 9 1.5C10.5875 1.5 11.9844 2.05625 13.1906 3.16875C14.3969 4.28125 15 5.775 15 7.65C15 8.2125 14.8906 8.80313 14.6719 9.42188C14.4531 10.0406 14.1344 10.6844 13.7156 11.3531C13.2969 12.0219 12.775 12.7125 12.15 13.425C11.525 14.1375 10.8063 14.8688 9.99375 15.6188C9.85625 15.7438 9.7 15.8375 9.525 15.9C9.35 15.9625 9.175 15.9938 9 15.9938ZM9 9C9.4125 9 9.76563 8.85313 10.0594 8.55938C10.3531 8.26563 10.5 7.9125 10.5 7.5C10.5 7.0875 10.3531 6.73438 10.0594 6.44063C9.76563 6.14688 9.4125 6 9 6C8.5875 6 8.23438 6.14688 7.94063 6.44063C7.64688 6.73438 7.5 7.0875 7.5 7.5C7.5 7.9125 7.64688 8.26563 7.94063 8.55938C8.23438 8.85313 8.5875 9 9 9Z"
				fill="#6F6B80" />
		</svg>
	)
}

export const CloseModelIcon = () => {
	return (
		<svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
			fill="none" viewBox="0 0 14 14">
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
				strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
		</svg>
	)
}

export const ToastMessageIcon = () => {
	return (
		<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.66862 10.5542L7.5207 9.42604C7.37556 9.2809 7.19414 9.20834 6.97643 9.20834C6.75872 9.20834 6.5707 9.2875 6.41237 9.44584C6.26723 9.59097 6.19466 9.7757 6.19466 10C6.19466 10.2243 6.26723 10.409 6.41237 10.5542L8.11445 12.2563C8.27279 12.4146 8.45751 12.4938 8.66862 12.4938C8.87973 12.4938 9.06445 12.4146 9.22279 12.2563L12.5874 8.89167C12.7457 8.73334 12.8216 8.54861 12.815 8.3375C12.8084 8.12639 12.7325 7.94167 12.5874 7.78334C12.429 7.625 12.241 7.54254 12.0233 7.53594C11.8056 7.52934 11.6176 7.60521 11.4592 7.76354L8.66862 10.5542ZM6.45195 17.7188L5.30404 15.7792L3.12695 15.3042C2.92904 15.2646 2.7707 15.1623 2.65195 14.9974C2.5332 14.8325 2.48702 14.651 2.51341 14.4531L2.73112 12.2167L1.24674 10.5146C1.1148 10.3694 1.04883 10.1979 1.04883 10C1.04883 9.80209 1.1148 9.63056 1.24674 9.48542L2.73112 7.78334L2.51341 5.54688C2.48702 5.34896 2.5332 5.16754 2.65195 5.00261C2.7707 4.83768 2.92904 4.73542 3.12695 4.69584L5.30404 4.22084L6.45195 2.28125C6.55751 2.10972 6.70265 1.99427 6.88737 1.9349C7.07209 1.87552 7.25681 1.88542 7.44154 1.96459L9.49987 2.83542L11.5582 1.96459C11.7429 1.88542 11.9276 1.87552 12.1124 1.9349C12.2971 1.99427 12.4422 2.10972 12.5478 2.28125L13.6957 4.22084L15.8728 4.69584C16.0707 4.73542 16.229 4.83768 16.3478 5.00261C16.4665 5.16754 16.5127 5.34896 16.4863 5.54688L16.2686 7.78334L17.753 9.48542C17.8849 9.63056 17.9509 9.80209 17.9509 10C17.9509 10.1979 17.8849 10.3694 17.753 10.5146L16.2686 12.2167L16.4863 14.4531C16.5127 14.651 16.4665 14.8325 16.3478 14.9974C16.229 15.1623 16.0707 15.2646 15.8728 15.3042L13.6957 15.7792L12.5478 17.7188C12.4422 17.8903 12.2971 18.0057 12.1124 18.0651C11.9276 18.1245 11.7429 18.1146 11.5582 18.0354L9.49987 17.1646L7.44154 18.0354C7.25681 18.1146 7.07209 18.1245 6.88737 18.0651C6.70265 18.0057 6.55751 17.8903 6.45195 17.7188Z"
				fill="white" />
		</svg>
	)
}

export const ToastMessageIcon2 = () => {
	return (
		<svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24"
			height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
			strokeLinecap="round" >
			<path d="M18 6 6 18" />
			<path d="m6 6 12 12" />
		</svg>
	)
}

export const ManagerIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.6">
				<path
					d="M3 15.75C2.5875 15.75 2.23438 15.6031 1.94063 15.3094C1.64687 15.0156 1.5 14.6625 1.5 14.25V6C1.5 5.5875 1.64687 5.23437 1.94063 4.94062C2.23438 4.64687 2.5875 4.5 3 4.5H6V3C6 2.5875 6.14688 2.23437 6.44063 1.94062C6.73438 1.64687 7.0875 1.5 7.5 1.5H10.5C10.9125 1.5 11.2656 1.64687 11.5594 1.94062C11.8531 2.23437 12 2.5875 12 3V4.5H15C15.4125 4.5 15.7656 4.64687 16.0594 4.94062C16.3531 5.23437 16.5 5.5875 16.5 6V14.25C16.5 14.6625 16.3531 15.0156 16.0594 15.3094C15.7656 15.6031 15.4125 15.75 15 15.75H3ZM7.5 4.5H10.5V3H7.5V4.5Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const OwnerIcon = () => {
	return (
		<svg width="18" height="19" viewBox="0 0 18 19" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.6">
				<path
					d="M9 17.3C7.9625 17.3 6.9875 17.1032 6.075 16.7094C5.1625 16.3157 4.36875 15.7813 3.69375 15.1063C3.01875 14.4313 2.48438 13.6375 2.09063 12.725C1.69688 11.8125 1.5 10.8375 1.5 9.80005C1.5 8.76255 1.69688 7.78755 2.09063 6.87505C2.48438 5.96255 3.01875 5.1688 3.69375 4.4938C4.36875 3.8188 5.1625 3.28442 6.075 2.89067C6.9875 2.49692 7.9625 2.30005 9 2.30005C10.0375 2.30005 11.0125 2.49692 11.925 2.89067C12.8375 3.28442 13.6313 3.8188 14.3063 4.4938C14.9813 5.1688 15.5156 5.96255 15.9094 6.87505C16.3031 7.78755 16.5 8.76255 16.5 9.80005C16.5 10.8375 16.3031 11.8125 15.9094 12.725C15.5156 13.6375 14.9813 14.4313 14.3063 15.1063C13.6313 15.7813 12.8375 16.3157 11.925 16.7094C11.0125 17.1032 10.0375 17.3 9 17.3ZM7.5 12.8H10.5C10.7125 12.8 10.8906 12.7282 11.0344 12.5844C11.1781 12.4407 11.25 12.2625 11.25 12.05V11.3C11.25 11.0875 11.1781 10.9094 11.0344 10.7657C10.8906 10.6219 10.7125 10.55 10.5 10.55C10.2875 10.55 10.1094 10.6219 9.96563 10.7657C9.82188 10.9094 9.75 11.0875 9.75 11.3H8.25V8.30005H9.75C9.75 8.51255 9.82188 8.69067 9.96563 8.83442C10.1094 8.97817 10.2875 9.05005 10.5 9.05005C10.7125 9.05005 10.8906 8.97817 11.0344 8.83442C11.1781 8.69067 11.25 8.51255 11.25 8.30005V7.55005C11.25 7.33755 11.1781 7.15942 11.0344 7.01567C10.8906 6.87192 10.7125 6.80005 10.5 6.80005H7.5C7.2875 6.80005 7.10938 6.87192 6.96563 7.01567C6.82188 7.15942 6.75 7.33755 6.75 7.55005V12.05C6.75 12.2625 6.82188 12.4407 6.96563 12.5844C7.10938 12.7282 7.2875 12.8 7.5 12.8Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const EmailIcon2 = () => {
	return (
		<svg width="18" height="19" viewBox="0 0 18 19" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.6">
				<path
					d="M3 15.6C2.5875 15.6 2.23438 15.4531 1.94063 15.1593C1.64687 14.8656 1.5 14.5125 1.5 14.1V5.09998C1.5 4.68748 1.64687 4.33435 1.94063 4.0406C2.23438 3.74685 2.5875 3.59998 3 3.59998H15C15.4125 3.59998 15.7656 3.74685 16.0594 4.0406C16.3531 4.33435 16.5 4.68748 16.5 5.09998V14.1C16.5 14.5125 16.3531 14.8656 16.0594 15.1593C15.7656 15.4531 15.4125 15.6 15 15.6H3ZM9 10.2187C9.0625 10.2187 9.12813 10.2094 9.19688 10.1906C9.26563 10.1719 9.33125 10.1437 9.39375 10.1062L14.7 6.78748C14.8 6.72498 14.875 6.64685 14.925 6.5531C14.975 6.45935 15 6.35623 15 6.24373C15 5.99373 14.8938 5.80623 14.6813 5.68123C14.4688 5.55623 14.25 5.56248 14.025 5.69998L9 8.84998L3.975 5.69998C3.75 5.56248 3.53125 5.55935 3.31875 5.6906C3.10625 5.82185 3 6.00623 3 6.24373C3 6.36873 3.025 6.4781 3.075 6.57185C3.125 6.6656 3.2 6.73748 3.3 6.78748L8.60625 10.1062C8.66875 10.1437 8.73438 10.1719 8.80313 10.1906C8.87188 10.2094 8.9375 10.2187 9 10.2187Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const PhoneIcon2 = () => {
	return (
		<svg width="18" height="19" viewBox="0 0 18 19" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.6">
				<path
					d="M14.9625 16.15C13.4 16.15 11.8563 15.8094 10.3313 15.1281C8.80625 14.4469 7.41875 13.4813 6.16875 12.2313C4.91875 10.9813 3.95312 9.59377 3.27188 8.06877C2.59063 6.54377 2.25 5.00002 2.25 3.43752C2.25 3.21252 2.325 3.02502 2.475 2.87502C2.625 2.72502 2.8125 2.65002 3.0375 2.65002H6.075C6.25 2.65002 6.40625 2.7094 6.54375 2.82815C6.68125 2.9469 6.7625 3.08752 6.7875 3.25002L7.275 5.87502C7.3 6.07502 7.29375 6.24377 7.25625 6.38127C7.21875 6.51877 7.15 6.63752 7.05 6.73752L5.23125 8.57502C5.48125 9.03752 5.77813 9.4844 6.12188 9.91565C6.46563 10.3469 6.84375 10.7625 7.25625 11.1625C7.64375 11.55 8.05 11.9094 8.475 12.2407C8.9 12.5719 9.35 12.875 9.825 13.15L11.5875 11.3875C11.7 11.275 11.8469 11.1906 12.0281 11.1344C12.2094 11.0781 12.3875 11.0625 12.5625 11.0875L15.15 11.6125C15.325 11.6625 15.4688 11.7531 15.5813 11.8844C15.6938 12.0156 15.75 12.1625 15.75 12.325V15.3625C15.75 15.5875 15.675 15.775 15.525 15.925C15.375 16.075 15.1875 16.15 14.9625 16.15Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const FaxIcon = () => {
	return (
		<svg width="18" height="19" viewBox="0 0 18 19" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.6">
				<path
					d="M6 15.2V4.69995C6 4.28745 6.14688 3.93433 6.44063 3.64058C6.73438 3.34683 7.0875 3.19995 7.5 3.19995H12C12.4125 3.19995 12.7656 3.34683 13.0594 3.64058C13.3531 3.93433 13.5 4.28745 13.5 4.69995V6.94995H14.25C14.875 6.94995 15.4063 7.1687 15.8438 7.6062C16.2813 8.0437 16.5 8.57495 16.5 9.19995V13.7C16.5 14.1125 16.3531 14.4656 16.0594 14.7593C15.7656 15.0531 15.4125 15.2 15 15.2H6ZM3.375 15.95C3.9 15.95 4.34375 15.7687 4.70625 15.4062C5.06875 15.0437 5.25 14.6 5.25 14.075V8.07495C5.25 7.54995 5.06875 7.1062 4.70625 6.7437C4.34375 6.3812 3.9 6.19995 3.375 6.19995C2.85 6.19995 2.40625 6.3812 2.04375 6.7437C1.68125 7.1062 1.5 7.54995 1.5 8.07495V14.075C1.5 14.6 1.68125 15.0437 2.04375 15.4062C2.40625 15.7687 2.85 15.95 3.375 15.95ZM7.5 6.94995H12V4.69995H7.5V6.94995ZM12 10.7C12.2125 10.7 12.3906 10.6281 12.5344 10.4843C12.6781 10.3406 12.75 10.1625 12.75 9.94995C12.75 9.73745 12.6781 9.55933 12.5344 9.41558C12.3906 9.27183 12.2125 9.19995 12 9.19995C11.7875 9.19995 11.6094 9.27183 11.4656 9.41558C11.3219 9.55933 11.25 9.73745 11.25 9.94995C11.25 10.1625 11.3219 10.3406 11.4656 10.4843C11.6094 10.6281 11.7875 10.7 12 10.7ZM14.25 10.7C14.4625 10.7 14.6406 10.6281 14.7844 10.4843C14.9281 10.3406 15 10.1625 15 9.94995C15 9.73745 14.9281 9.55933 14.7844 9.41558C14.6406 9.27183 14.4625 9.19995 14.25 9.19995C14.0375 9.19995 13.8594 9.27183 13.7156 9.41558C13.5719 9.55933 13.5 9.73745 13.5 9.94995C13.5 10.1625 13.5719 10.3406 13.7156 10.4843C13.8594 10.6281 14.0375 10.7 14.25 10.7ZM12 12.95C12.2125 12.95 12.3906 12.8781 12.5344 12.7343C12.6781 12.5906 12.75 12.4125 12.75 12.2C12.75 11.9875 12.6781 11.8093 12.5344 11.6656C12.3906 11.5218 12.2125 11.45 12 11.45C11.7875 11.45 11.6094 11.5218 11.4656 11.6656C11.3219 11.8093 11.25 11.9875 11.25 12.2C11.25 12.4125 11.3219 12.5906 11.4656 12.7343C11.6094 12.8781 11.7875 12.95 12 12.95ZM14.25 12.95C14.4625 12.95 14.6406 12.8781 14.7844 12.7343C14.9281 12.5906 15 12.4125 15 12.2C15 11.9875 14.9281 11.8093 14.7844 11.6656C14.6406 11.5218 14.4625 11.45 14.25 11.45C14.0375 11.45 13.8594 11.5218 13.7156 11.6656C13.5719 11.8093 13.5 11.9875 13.5 12.2C13.5 12.4125 13.5719 12.5906 13.7156 12.7343C13.8594 12.8781 14.0375 12.95 14.25 12.95ZM8.25 12.95H9.75C9.9625 12.95 10.1406 12.8781 10.2844 12.7343C10.4281 12.5906 10.5 12.4125 10.5 12.2V9.94995C10.5 9.73745 10.4281 9.55933 10.2844 9.41558C10.1406 9.27183 9.9625 9.19995 9.75 9.19995H8.25C8.0375 9.19995 7.85938 9.27183 7.71563 9.41558C7.57188 9.55933 7.5 9.73745 7.5 9.94995V12.2C7.5 12.4125 7.57188 12.5906 7.71563 12.7343C7.85938 12.8781 8.0375 12.95 8.25 12.95Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const PatientNameIcon = () => {

	return (
		<svg width="20" height="21" viewBox="0 0 20 21" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.5">
				<path
					d="M9.99967 10.5C9.08301 10.5 8.29829 10.1737 7.64551 9.52087C6.99273 8.8681 6.66634 8.08337 6.66634 7.16671C6.66634 6.25004 6.99273 5.46532 7.64551 4.81254C8.29829 4.15976 9.08301 3.83337 9.99967 3.83337C10.9163 3.83337 11.7011 4.15976 12.3538 4.81254C13.0066 5.46532 13.333 6.25004 13.333 7.16671C13.333 8.08337 13.0066 8.8681 12.3538 9.52087C11.7011 10.1737 10.9163 10.5 9.99967 10.5ZM3.33301 15.5V14.8334C3.33301 14.3612 3.45454 13.9271 3.69759 13.5313C3.94065 13.1355 4.26356 12.8334 4.66634 12.625C5.52745 12.1945 6.40245 11.8716 7.29134 11.6563C8.18023 11.441 9.08301 11.3334 9.99967 11.3334C10.9163 11.3334 11.8191 11.441 12.708 11.6563C13.5969 11.8716 14.4719 12.1945 15.333 12.625C15.7358 12.8334 16.0587 13.1355 16.3018 13.5313C16.5448 13.9271 16.6663 14.3612 16.6663 14.8334V15.5C16.6663 15.9584 16.5031 16.3507 16.1768 16.6771C15.8504 17.0035 15.458 17.1667 14.9997 17.1667H4.99967C4.54134 17.1667 4.14898 17.0035 3.82259 16.6771C3.4962 16.3507 3.33301 15.9584 3.33301 15.5Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const DobIcon = () => {
	return (
		<svg width="20" height="21" viewBox="0 0 20 21" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.5">
				<path
					d="M3.33333 18.8334C3.09722 18.8334 2.89931 18.7535 2.73958 18.5938C2.57986 18.4341 2.5 18.2362 2.5 18V14.6667C2.5 14.2084 2.66319 13.816 2.98958 13.4896C3.31597 13.1632 3.70833 13 4.16667 13H15.8333C16.2917 13 16.684 13.1632 17.0104 13.4896C17.3368 13.816 17.5 14.2084 17.5 14.6667V18C17.5 18.2362 17.4201 18.4341 17.2604 18.5938C17.1007 18.7535 16.9028 18.8334 16.6667 18.8334H3.33333ZM4.16667 11.3334V8.83337C4.16667 8.37504 4.32986 7.98268 4.65625 7.65629C4.98264 7.3299 5.375 7.16671 5.83333 7.16671H9.16667V5.95837C8.91667 5.79171 8.71528 5.59032 8.5625 5.35421C8.40972 5.1181 8.33333 4.83337 8.33333 4.50004C8.33333 4.29171 8.375 4.08685 8.45833 3.88546C8.54167 3.68407 8.66667 3.50004 8.83333 3.33337L9.70833 2.45837C9.73611 2.4306 9.83333 2.38893 10 2.33337C10.0278 2.33337 10.125 2.37504 10.2917 2.45837L11.1667 3.33337C11.3333 3.50004 11.4583 3.68407 11.5417 3.88546C11.625 4.08685 11.6667 4.29171 11.6667 4.50004C11.6667 4.83337 11.5903 5.1181 11.4375 5.35421C11.2847 5.59032 11.0833 5.79171 10.8333 5.95837V7.16671H14.1667C14.625 7.16671 15.0174 7.3299 15.3438 7.65629C15.6701 7.98268 15.8333 8.37504 15.8333 8.83337V11.3334H4.16667Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const TransferringIcon = () => {
	return (
		<svg width="20" height="21" viewBox="0 0 20 21" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.5">
				<path
					d="M3.33366 17.1667C2.87533 17.1667 2.48296 17.0035 2.15658 16.6771C1.83019 16.3507 1.66699 15.9584 1.66699 15.5V5.50004C1.66699 5.04171 1.83019 4.64935 2.15658 4.32296C2.48296 3.99657 2.87533 3.83337 3.33366 3.83337H16.667C17.1253 3.83337 17.5177 3.99657 17.8441 4.32296C18.1705 4.64935 18.3337 5.04171 18.3337 5.50004V15.5C18.3337 15.9584 18.1705 16.3507 17.8441 16.6771C17.5177 17.0035 17.1253 17.1667 16.667 17.1667H3.33366ZM10.0003 11.1875C10.0698 11.1875 10.1427 11.1771 10.2191 11.1563C10.2955 11.1355 10.3684 11.1042 10.4378 11.0625L16.3337 7.37504C16.4448 7.3056 16.5281 7.21879 16.5837 7.11462C16.6392 7.01046 16.667 6.89587 16.667 6.77087C16.667 6.4931 16.5489 6.28476 16.3128 6.14587C16.0767 6.00698 15.8337 6.01393 15.5837 6.16671L10.0003 9.66671L4.41699 6.16671C4.16699 6.01393 3.92394 6.01046 3.68783 6.15629C3.45171 6.30212 3.33366 6.50698 3.33366 6.77087C3.33366 6.90976 3.36144 7.03129 3.41699 7.13546C3.47255 7.23962 3.55588 7.31948 3.66699 7.37504L9.56283 11.0625C9.63227 11.1042 9.70519 11.1355 9.78158 11.1563C9.85796 11.1771 9.93088 11.1875 10.0003 11.1875Z"
					fill="#1B2336" />
			</g>
		</svg>
	)
}

export const PhnIcon = () => {
	return (
		// <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		// 	<g opacity="0.6">
		// 		<path d="M16.625 18C14.8889 18 13.1736 17.6215 11.4792 16.8646C9.78472 16.1076 8.24306 15.0347 6.85417 13.6458C5.46528 12.2569 4.39236 10.7153 3.63542 9.02083C2.87847 7.32639 2.5 5.61111 2.5 3.875C2.5 3.625 2.58333 3.41667 2.75 3.25C2.91667 3.08333 3.125 3 3.375 3H6.75C6.94444 3 7.11806 3.06597 7.27083 3.19792C7.42361 3.32986 7.51389 3.48611 7.54167 3.66667L8.08333 6.58333C8.11111 6.80556 8.10417 6.99306 8.0625 7.14583C8.02083 7.29861 7.94444 7.43056 7.83333 7.54167L5.8125 9.58333C6.09028 10.0972 6.42014 10.5938 6.80208 11.0729C7.18403 11.5521 7.60417 12.0139 8.0625 12.4583C8.49306 12.8889 8.94444 13.2882 9.41667 13.6562C9.88889 14.0243 10.3889 14.3611 10.9167 14.6667L12.875 12.7083C13 12.5833 13.1632 12.4896 13.3646 12.4271C13.566 12.3646 13.7639 12.3472 13.9583 12.375L16.8333 12.9583C17.0278 13.0139 17.1875 13.1146 17.3125 13.2604C17.4375 13.4062 17.5 13.5694 17.5 13.75V17.125C17.5 17.375 17.4167 17.5833 17.25 17.75C17.0833 17.9167 16.875 18 16.625 18Z" fill="#1B2336" />
		// 	</g>
		// </svg>

		<svg width="22" height="22" viewBox="0 0 20 22" className="" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M21.0165 17.6336H3.83636V16.4336H21.0165V17.6336Z" fill="gray" />
			<path d="M7.09808 13.3967V7.50803H5.74066L3.83636 8.78244V10.091L5.65277 8.88498H5.74066V13.3967H3.84125V14.5539H8.89984V13.3967H7.09808Z" fill="gray" />
			<path d="M9.81781 9.63205V9.66135H11.1069V9.62717C11.1069 8.95334 11.5756 8.49435 12.2739 8.49435C12.9575 8.49435 13.4018 8.89474 13.4018 9.5051C13.4018 9.97873 13.1528 10.3498 12.1909 11.3117L9.89594 13.5822V14.5539H14.8618V13.3869H11.7807V13.299L13.1577 11.9856C14.3491 10.843 14.7543 10.1838 14.7543 9.41232C14.7543 8.19162 13.7729 7.36642 12.3178 7.36642C10.8383 7.36642 9.81781 8.28439 9.81781 9.63205Z" fill="gray" />
			<path d="M17.6694 11.4631H18.5092C19.3198 11.4631 19.8422 11.8684 19.8422 12.4983C19.8422 13.1184 19.3295 13.5139 18.5239 13.5139C17.767 13.5139 17.2592 13.133 17.2104 12.5324H15.9262C15.9897 13.8508 17.0248 14.6955 18.5629 14.6955C20.1401 14.6955 21.2192 13.841 21.2192 12.591C21.2192 11.6584 20.6528 11.0334 19.7006 10.9211V10.8332C20.4721 10.677 20.9457 10.0666 20.9457 9.23654C20.9457 8.12326 19.9741 7.36642 18.5434 7.36642C17.0541 7.36642 16.1118 8.17697 16.0629 9.50021H17.2983C17.3422 8.8801 17.8061 8.48459 18.4995 8.48459C19.2075 8.48459 19.6567 8.85568 19.6567 9.44162C19.6567 10.0324 19.1977 10.4182 18.4946 10.4182H17.6694V11.4631Z" fill="gray" />
		</svg>
	)
}

export const AnalyticsIcon = () => {

	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-white">
			<path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
		</svg>
	)
}

export const UploadPrescritption = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-white">
			<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
		</svg>

	)
}

export const isTransferIcon = () => {
	return (
		// <svg width="14px" height="18px" viewBox="0 0 25 25" fill="red" xmlns="http://www.w3.org/2000/svg">
		// 	<path d="M19.5 16.5H6M5.5 8.5L19 8.5" stroke="red" strokeWidth="1.2" />
		// 	<path d="M16 13L19.5 16.5L16 20M9 12L5.5 8.5L9 5" stroke="red" strokeWidth="1.2" />
		// </svg>

		<svg height="18" viewBox="0 -1 466.66222 466" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m16 .332031h320c8.835938 0 16 7.164063 16 16v432c0 8.835938-7.164062 16-16 16h-320c-8.835938 0-16-7.164062-16-16v-432c0-8.835937 7.164062-16 16-16zm0 0" fill="#57b7eb" /><path d="m200 400.332031c-79.527344 0-144-64.472656-144-144v-256h-40c-8.835938 0-16 7.164063-16 16v432c0 8.835938 7.164062 16 16 16h320c8.835938 0 16-7.164062 16-16v-48zm0 0" fill="#4891d3" /><path d="m72 48.332031h208v32h-208zm0 0" fill="#f9e109" /><g fill="#39519d"><path d="m256 120.332031h-160c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h160c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0" /><path d="m304 176.332031h-176c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h176c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0" /><path d="m216 224.332031h-160c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h160c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0" /><path d="m304 224.332031h-56c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h56c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0" /><path d="m136 264.332031h-80c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h80c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0" /><path d="m224 264.332031h-56c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h56c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0" /></g><path d="m280 80.332031h-208v-32zm0 0" fill="#fcbc04" /><path d="m152 372.332031c0 33.136719-26.863281 60-60 60s-60-26.863281-60-60 26.863281-60 60-60 60 26.863281 60 60zm0 0" fill="#f9e109" /><path d="m92 432.332031c25.980469-.007812 49.003906-16.734375 57.039062-41.441406-35.207031-13.359375-63.785156-39.980469-79.597656-74.160156-26.605468 10.792969-41.835937 38.917969-36.335937 67.09375 5.496093 28.175781 30.1875 48.511719 58.894531 48.507812zm0 0" fill="#fcbc04" /><path d="m192 408.332031c-.871094.027344-1.738281-.105469-2.558594-.402343-4.164062-1.402344-6.414062-5.90625-5.042968-10.078126l19.679687-59.039062c2.410156-7.207031 9.554687-11.722656 17.09375-10.8125 7.542969.910156 13.402344 7 14.027344 14.570312l2.722656 32 2.878906-4.878906c3.058594-5.335937 8.90625-8.445312 15.039063-8 6.035156.503906 11.269531 4.375 13.519531 10l5.121094 12.640625 23.28125-29.601562c1.320312-1.671875 3.253906-2.746094 5.371093-2.988281 2.117188-.238282 4.246094.375 5.90625 1.707031 3.433594 2.75 4.003907 7.75 1.28125 11.203125l-23.359374 29.679687c-3.5625 4.449219-9.21875 6.667969-14.855469 5.828125s-10.398438-4.613281-12.503907-9.910156l-4.960937-12.558594-2.960937 4.878906c-3.484376 5.921876-10.359376 8.957032-17.082032 7.542969-6.722656-1.410156-11.792968-6.960937-12.597656-13.78125l-2.71875-32.480469-19.28125 58.71875c-1.027344 3.53125-4.328125 5.90625-8 5.761719zm0 0" fill="#39519d" /><path d="m89.921875 395.050781c-4.226563.003907-8.28125-1.664062-11.28125-4.640625l-16.960937-16.960937c-1.515626-1.5-2.367188-3.546875-2.367188-5.679688 0-2.132812.851562-4.175781 2.367188-5.679687 3.121093-3.101563 8.160156-3.101563 11.28125 0l16.960937 16.960937 28.316406-28.238281c3.175781-2.71875 7.90625-2.535156 10.863281.417969 2.953126 2.957031 3.136719 7.6875.417969 10.859375l-28.238281 28.320312c-3.019531 2.996094-7.109375 4.664063-11.359375 4.640625zm0 0" fill="#39519d" /><path d="m395.25 155.738281 41.570312 24-72 124.710938-41.570312-24zm0 0" fill="#fcbc04" /><path d="m360.800781 215.371094-37.601562 64.960937 41.601562 24 12.160157-21.199219c-9.019532-21.566406-14.476563-44.449218-16.160157-67.761718zm0 0" fill="#e59730" /><path d="m364.800781 304.492188-41.601562-24-17.039063 45.519531 27.679688 16zm0 0" fill="#a1d51c" /><path d="m307.398438 327.464844 27.839843 16-8 13.917968c-4.417969 7.6875-14.230469 10.339844-21.917969 5.921876-7.6875-4.417969-10.339843-14.234376-5.921874-21.921876zm0 0" fill="#e59730" /><path d="m419.179688 114.203125 41.570312 24-24 41.570313-41.570312-24zm0 0" fill="#fcbc04" /><path d="m455.964844 98.496094c7.652344 4.417968 10.273437 14.203125 5.855468 21.855468l-8 13.855469-27.710937-16 8-13.855469c4.417969-7.652343 14.203125-10.277343 21.855469-5.855468zm0 0" fill="#c4f236" /><path d="m384.320312 174.753906 8-13.855468 41.570313 24-8 13.855468zm0 0" fill="#e59730" /><path d="m424.480469 273.050781c-1.402344.011719-2.78125-.347656-4-1.039062-1.839844-1.070313-3.175781-2.828125-3.714844-4.882813-.542969-2.054687-.242187-4.242187.835937-6.078125l32-55.441406c1.0625-1.839844 1.351563-4.027344.796876-6.078125-.550782-2.0625-1.902344-3.820312-3.757813-4.878906l-69.28125-40c-3.808594-2.199219-5.128906-7.058594-2.960937-10.882813 1.058593-1.851562 2.808593-3.203125 4.867187-3.757812 2.054687-.558594 4.25-.269531 6.09375.800781l69.28125 40c5.515625 3.175781 9.542969 8.410156 11.199219 14.558594 1.65625 6.15625.792968 12.71875-2.398438 18.238281l-32 55.441406c-1.4375 2.484375-4.09375 4.011719-6.960937 4zm0 0" fill="#39519d" /><path d="m448 104.332031c.039062-2.703125.417969-5.390625 1.121094-8-6.105469-.414062-11.914063 2.691407-14.960938 8l-8 13.839844 27.679688 16 4-6.878906c-6.300782-5.972657-9.863282-14.28125-9.839844-22.960938zm0 0" fill="#a1d51c" /></svg>
	)
}


export const HomeIcons = ({ color = '#034ea2' }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			width="24"
			height="24"
			x="0"
			y="0"
			viewBox="0 0 511 511.999"
			style={{ enableBackground: 'new 0 0 512 512' }}
		>
			<g>
				<path
					d="M498.7 222.695c-.016-.011-.028-.027-.04-.039L289.805 13.81C280.902 4.902 269.066 0 256.477 0c-12.59 0-24.426 4.902-33.332 13.809L14.398 222.55c-.07.07-.144.144-.21.215-18.282 18.386-18.25 48.218.09 66.558 8.378 8.383 19.44 13.235 31.273 13.746.484.047.969.07 1.457.07h8.32v153.696c0 30.418 24.75 55.164 55.168 55.164h81.711c8.285 0 15-6.719 15-15V376.5c0-13.879 11.293-25.168 25.172-25.168h48.195c13.88 0 25.168 11.29 25.168 25.168V497c0 8.281 6.715 15 15 15h81.711c30.422 0 55.168-24.746 55.168-55.164V303.14h7.719c12.586 0 24.422-4.903 33.332-13.813 18.36-18.367 18.367-48.254.027-66.633zm-21.243 45.422a17.03 17.03 0 0 1-12.117 5.024H442.62c-8.285 0-15 6.714-15 15v168.695c0 13.875-11.289 25.164-25.168 25.164h-66.71V376.5c0-30.418-24.747-55.168-55.169-55.168H232.38c-30.422 0-55.172 24.75-55.172 55.168V482h-66.71c-13.876 0-25.169-11.29-25.169-25.164V288.14c0-8.286-6.715-15-15-15H48a13.9 13.9 0 0 0-.703-.032c-4.469-.078-8.66-1.851-11.8-4.996-6.68-6.68-6.68-17.55 0-24.234.003 0 .003-.004.007-.008l.012-.012L244.363 35.02A17.003 17.003 0 0 1 256.477 30c4.574 0 8.875 1.781 12.113 5.02l208.8 208.796.098.094c6.645 6.692 6.633 17.54-.031 24.207zm0 0"
					fill="#6b7280"
					opacity="1"
				/>
			</g>
		</svg>
	)
}


export const MessageIcon = ({ color = '#034ea2' }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			x="0"
			y="0"
			viewBox="0 0 32 32"
			style={{ enableBackground: "new 0 0 512 512" }}
			xmlSpace="preserve"
		>
			<g>
				<path
					d="M8 30a1.001 1.001 0 0 1-1-1v-5H4c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h24c1.654 0 3 1.346 3 3v16c0 1.654-1.346 3-3 3H15.851l-7.226 5.781A.998.998 0 0 1 8 30zM4 4c-.552 0-1 .449-1 1v16c0 .551.448 1 1 1h4a1 1 0 0 1 1 1v3.92l5.875-4.701A1 1 0 0 1 15.5 22H28c.552 0 1-.449 1-1V5c0-.551-.448-1-1-1z"
					fill={color}
					opacity="1"
				/>
				<path
					d="M24 12H8a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zM16 16H8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2z"
					fill={color}
					opacity="1"
				/>
			</g>
		</svg>

	)
}



export const HelpIcon = ({ color = '#034ea2' }) => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				version="1.1"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				width="24"
				height="24"
				x="0"
				y="0"
				viewBox="0 0 512 512"
				style={{ enableBackground: 'new 0 0 512 512' }}
				xmlSpace="preserve"
			>
				<g>
					<path
						d="M256 0C114.509 0 0 114.496 0 256c0 141.489 114.496 256 256 256 141.491 0 256-114.496 256-256C512 114.509 397.504 0 256 0zm0 476.279c-121.462 0-220.279-98.816-220.279-220.279S134.538 35.721 256 35.721c121.463 0 220.279 98.816 220.279 220.279S377.463 476.279 256 476.279z"
						fill={color}
						opacity="1"
						data-original="#000000"
					/>
					<path
						d="M248.425 323.924c-14.153 0-25.61 11.794-25.61 25.946 0 13.817 11.12 25.948 25.61 25.948s25.946-12.131 25.946-25.948c0-14.152-11.794-25.946-25.946-25.946zM252.805 127.469c-45.492 0-66.384 26.959-66.384 45.155 0 13.142 11.12 19.208 20.218 19.208 18.197 0 10.784-25.948 45.155-25.948 16.848 0 30.328 7.414 30.328 22.915 0 18.196-18.871 28.642-29.991 38.077-9.773 8.423-22.577 22.24-22.577 51.22 0 17.522 4.718 22.577 18.533 22.577 16.511 0 19.881-7.413 19.881-13.817 0-17.522.337-27.631 18.871-42.121 9.098-7.076 37.74-29.991 37.74-61.666s-28.642-55.6-71.774-55.6z"
						fill={color}
						opacity="1"
						data-original="#000000"
					/>
				</g>
			</svg>

		</>
	)
}


export const LogoutIcon = ({ color = '#034ea2' }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 20 19" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.45833 16.625C4.02292 16.625 3.65017 16.47 3.3401 16.1599C3.03003 15.8498 2.875 15.4771 2.875 15.0417V3.95833C2.875 3.52292 3.03003 3.15017 3.3401 2.8401C3.65017 2.53003 4.02292 2.375 4.45833 2.375H9.20833C9.43264 2.375 9.62066 2.45087 9.7724 2.6026C9.92413 2.75434 10 2.94236 10 3.16667C10 3.39097 9.92413 3.57899 9.7724 3.73073C9.62066 3.88247 9.43264 3.95833 9.20833 3.95833H4.45833V15.0417H9.20833C9.43264 15.0417 9.62066 15.1175 9.7724 15.2693C9.92413 15.421 10 15.609 10 15.8333C10 16.0576 9.92413 16.2457 9.7724 16.3974C9.62066 16.5491 9.43264 16.625 9.20833 16.625H4.45833ZM14.0969 10.2917H8.41667C8.19236 10.2917 8.00434 10.2158 7.8526 10.0641C7.70087 9.91233 7.625 9.72431 7.625 9.5C7.625 9.27569 7.70087 9.08767 7.8526 8.93594C8.00434 8.7842 8.19236 8.70833 8.41667 8.70833H14.0969L12.6125 7.22396C12.4674 7.07882 12.3948 6.90069 12.3948 6.68958C12.3948 6.47847 12.4674 6.29375 12.6125 6.13542C12.7576 5.97708 12.9424 5.89462 13.1667 5.88802C13.391 5.88142 13.5823 5.95729 13.7406 6.11562L16.5708 8.94583C16.7292 9.10417 16.8083 9.28889 16.8083 9.5C16.8083 9.71111 16.7292 9.89583 16.5708 10.0542L13.7406 12.8844C13.5823 13.0427 13.3943 13.1186 13.1766 13.112C12.9589 13.1054 12.7708 13.0229 12.6125 12.8646C12.4674 12.7063 12.3981 12.5182 12.4047 12.3005C12.4113 12.0828 12.4872 11.9014 12.6323 11.7562L14.0969 10.2917Z"
				fill={color} />
		</svg>

	)
}

export const CameraIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		width="24"
		height="24"
		x="0"
		y="0"
		viewBox="0 0 32 32"
		style={{ enableBackground: 'new 0 0 512 512' }}
		className=""
	>
		<g>
			<path
				d="M27.348 7h-4.294l-.5-1.5A3.645 3.645 0 0 0 19.089 3h-6.178a3.646 3.646 0 0 0-3.464 2.5L8.946 7H4.652A3.656 3.656 0 0 0 1 10.652v14.7A3.656 3.656 0 0 0 4.652 29h22.7A3.656 3.656 0 0 0 31 25.348v-14.7A3.656 3.656 0 0 0 27.348 7ZM29 25.348A1.654 1.654 0 0 1 27.348 27H4.652A1.654 1.654 0 0 1 3 25.348v-14.7A1.654 1.654 0 0 1 4.652 9h5.015a1 1 0 0 0 .948-.684l.729-2.187A1.65 1.65 0 0 1 12.911 5h6.178a1.649 1.649 0 0 1 1.567 1.13l.729 2.186a1 1 0 0 0 .948.684h5.015A1.654 1.654 0 0 1 29 10.652Z"
				fill="#6b7280"
				opacity="1"
			/>
			<path
				d="M16 10a7.5 7.5 0 1 0 7.5 7.5A7.508 7.508 0 0 0 16 10Zm0 13a5.5 5.5 0 1 1 5.5-5.5A5.506 5.506 0 0 1 16 23Z"
				fill="#6b7280"
				opacity="1"
			/>
			<circle cx="26" cy="12" r="1" fill="#6b7280" opacity="1" />
		</g>
	</svg>
);

export const AttachmentIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		width="24"
		height="24"
		viewBox="0 0 48 48"
		style={{ enableBackground: 'new 0 0 512 512' }}
		className=""
	>
		<g>
			<path
				d="M35.5 34V16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v18c0 4.69-3.81 8.5-8.5 8.5s-8.5-3.81-8.5-8.5V11c0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5v21.5a2.5 2.5 0 0 1-5 0V13c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v19.5c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5V11c0-4.69-3.81-8.5-8.5-8.5s-8.5 3.81-8.5 8.5v23c0 6.34 5.16 11.5 11.5 11.5S35.5 40.34 35.5 34z"
				fill="#6b7280"
				opacity="1"
			/>
		</g>
	</svg>
);

export const GalleryIcon = () => (
	<svg
		id="Layer_1"
		height="44"
		viewBox="0 0 32 32"
		width="44"
		xmlns="http://www.w3.org/2000/svg"
	>
		<linearGradient id="linear-gradient" gradientUnits="userSpaceOnUse" x1="16" x2="16" y1="3.293" y2="19.2">
			<stop offset="0" stopColor="#4793eb" />
			<stop offset=".635" stopColor="#2367ec" />
			<stop offset="1" stopColor="#294ccd" />
		</linearGradient>
		<linearGradient id="linear-gradient-2" gradientUnits="userSpaceOnUse" x1="16" x2="16" y1="14.682" y2="28.745">
			<stop offset="0" stopColor="#4aff9e" />
			<stop offset="1" stopColor="#35b97d" />
		</linearGradient>
		<linearGradient id="linear-gradient-3" gradientUnits="userSpaceOnUse" x1="18.379" x2="22.621" y1="8.879" y2="13.121">
			<stop offset="0" stopColor="#fed200" />
			<stop offset=".272" stopColor="#fdce01" />
			<stop offset=".528" stopColor="#fbc205" />
			<stop offset=".776" stopColor="#f8b00c" />
			<stop offset="1" stopColor="#f59815" />
		</linearGradient>
		<path
			d="M24 29H8c-2.757 0-5-2.243-5-5V8c0-2.757 2.243-5 5-5h16c2.757 0 5 2.243 5 5v16c0 2.757-2.243 5-5 5z"
			fill="url(#linear-gradient)"
		/>
		<path
			d="M25.117 17.703c-1.167-1.168-3.067-1.168-4.234 0l-2.18 2.18c-.388.388-1.019.388-1.406 0l-4.18-4.18c-1.167-1.168-3.067-1.168-4.234 0l-5.883 5.883v2.414c0 2.757 2.243 5 5 5h16c2.757 0 5-2.243 5-5v-2.414z"
			fill="url(#linear-gradient-2)"
		/>
		<circle cx="20.5" cy="11" fill="url(#linear-gradient-3)" r="3" />
	</svg>
);

export const DocumentIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		width="44"
		height="44"
		viewBox="0 0 512 512"
		style={{ enableBackground: 'new 0 0 512 512' }}
		xmlSpace="preserve"
	>
		<g>
			{/* Blue background for the document */}
			<path
				fill="#518ff5"
				d="M441.4 140.2V479c0 18.2-14.8 33-33 33H103.6c-18.2 0-33-14.8-33-33V33c0-18.2 14.8-33 33-33h197.6z"
				opacity="1"
			></path>

			{/* White document lines */}
			<g fill="#fff">
				<path d="M161.2 257.1h189.6v21.1H161.2zM161.2 304.1h189.6v21.1H161.2zM161.2 351.2h189.6v21.1H161.2zM161.2 398.2h134.9v21.1H161.2z" />
			</g>

			{/* Shadow effect */}
			<path
				d="M320.3 134.9 441.4 233v-92.2L372.8 101z"
				opacity="1"
				fill="#00000019"
			></path>

			{/* Light blue document top corner */}
			<path
				fill="#a6c5fa"
				d="M441.4 140.2H334.2c-18.2 0-33-14.8-33-33V0z"
				opacity="1"
			></path>
		</g>
	</svg>
);


export const PDFIcon = () => (
	<svg
		width="64"
		height="64"
		version="1.1"
		id="Capa_1"
		xmlns="http://www.w3.org/2000/svg"
		x="0px"
		y="0px"
		viewBox="0 0 56 56"
		style={{ enableBackground: 'new 0 0 56 56' }}
		xmlSpace="preserve"
	>
		<g>
			<path
				style={{ fill: '#E9E9E0' }}
				d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
			c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
			/>
			<polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12" />
			<path
				style={{ fill: '#CC4B4C' }}
				d="M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326
			c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75
			c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172
			c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562
			c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16
			c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822
			c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198
			c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z
			M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415
			c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174
			c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z
			M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"
			/>
			<path
				style={{ fill: '#CC4B4C' }}
				d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
			/>
			<g>
				<path
					style={{ fill: '#FFFFFF' }}
					d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
			  c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
			  c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
			  s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
			  c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
			  c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492
			  c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
				/>
				<path
					style={{ fill: '#FFFFFF' }}
					d="M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937
			  s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035
			  c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z
			   M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244
			  c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"
				/>
				<path
					style={{ fill: '#FFFFFF' }}
					d="M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"
				/>
			</g>
		</g>
	</svg>
);


export const VoiCeIcon = () => {
	return (
	  <svg
		id="Layer_1"
		enableBackground="new 0 0 97 97"
		height="44"
		viewBox="0 0 97 97"
		width="44"
		xmlns="http://www.w3.org/2000/svg"
	  >
		<circle cx="48.5" cy="48.5" fill="#50af00" r="48" />
		<g fill="#fff">
		  <path d="m65.1 48.2c0-1.2-.9-2.1-2.1-2.1s-2 .9-2 2.1c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5c0-1.2-.9-2.1-2.1-2.1s-2.1.9-2.1 2.1c0 8.5 6.4 15.5 14.5 16.5v5.7c0 1.2.9 2.1 2.1 2.1s2.1-.9 2.1-2.1v-5.7c8.3-1.1 14.6-8.1 14.6-16.5z" />
		  <path d="m48.2 56.3h.7c4.3 0 7.7-3.5 7.7-7.7v-16.4c0-4.3-3.5-7.7-7.7-7.7h-.7c-4.3 0-7.7 3.5-7.7 7.7v16.3c-.1 4.3 3.4 7.8 7.7 7.8z" />
		</g>
	  </svg>
	);
  };
  